import { getToken } from "../auth";

export const API_URI = process.env.NODE_ENV === 'production' ? '/api/' : 'http://localhost:3030/';
export const fetchData = async (uri) => {
  try {
    const token = getToken();

    const response = await fetch(`${API_URI}${uri}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) throw new Error("Network response was not ok");
    if (response.status === 403) {
      alert("Votre session a expiré, veuillez vous reconnecter");
      throw new Error("Votre session a expiré, veuillez vous reconnecter");
    }
    return response.json();
  } catch (error) {
    console.error("Error fetching menus:", error);
    throw error;
  }
};

export const putData = async (uri, body) => {
  const token = getToken();
  const response = await fetch(`${API_URI}${uri}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error("Erreur PUT");
  return response.json();
};
